/**
 * Determine which page numbers to displaybased on current page
 * - Small number of pages: show every page.
 * - Near start: first [EDGE_WINDOW] pages, ellipsis, last.
 * - Near end: first, ellipsis, last [EDGE_WINDOW] pages.
 * - Middle: first, ellipsis, previous + current + next, ellipsis, last.
 */
export type VisiblePageItem = number | 'ellipsis';

export const PAGE_ELLIPSIS_THRESHOLD = 7;

const EDGE_WINDOW = 4;

export function getVisiblePageItems(currentPage: number, totalPages: number): VisiblePageItem[] {
  if (!Number.isFinite(currentPage) || !Number.isFinite(totalPages) || totalPages <= 1) {
    return [];
  }

  const current = Math.min(Math.max(1, Math.floor(currentPage)), Math.floor(totalPages));
  const total = Math.floor(totalPages);

  if (total <= PAGE_ELLIPSIS_THRESHOLD) {
    return Array.from({ length: total }, (_, index) => index + 1);
  }

  // Pages 1–3 keep the start window so the first four numbers stay visible.
  if (current <= EDGE_WINDOW - 1) {
    return [1, 2, 3, 4, 'ellipsis', total];
  }

  // Last three pages keep the end window so the last four numbers stay visible.
  if (current >= total - (EDGE_WINDOW - 2)) {
    return [1, 'ellipsis', total - 3, total - 2, total - 1, total];
  }

  return [1, 'ellipsis', current - 1, current, current + 1, 'ellipsis', total];
}
